import { map } from 'lodash'

const prepareShow = rental => {
  return rental
}

const prepareSave = rental => {
  return rental
}

export default {
  prepareSave,
  prepareShow,
  afterCreated () {
    this.$toast.success('Locação de Unidade incluida com sucesso.')
    return this.$router.push({name: 'dweller.rental.unit.index'})
  },
  afterUpdated () {
    this.$toast.success('Locação de Unidade alterada com sucesso.')
    return this.$router.push({name: 'dweller.rental.unit.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  /** Retornando as torres das uniades do dweller */
  getTowersDweller () {
    this.$http.get('/v1/dweller/towers/search')
      .then(({data}) => {
        const towers = map(data, function (item) {
          return {
            id: item.id,
            number: item.number + ' - ' + item.name
          }
        })
        this.dwellerTowers = towers
      })
  },
  /** Retornando as unidades da torre selecionada */
  selectUnitsTower (tower) {
    if (typeof tower === 'object') {
      this.$http.get('/v1/dweller/rental/units/search/' + tower.id)
      .then(({data}) => {
        this.dwellerRentalUnits = data
      })
    }

    if (typeof tower !== 'object') {
      this.$http.get('/v1/dweller/rental/units/search/' + tower)
      .then(({data}) => {
        this.dwellerRentalUnits = data
      })
    }
  },
  getGaragesDweller (unit) {
    if (typeof unit === 'object') {
      const search = {
        unit_id: unit.id,
        tower_id: this.rental.tower_id
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
    if (typeof unit !== 'object') {
      const search = {
        unit_id: unit,
        tower_id: this.rental.tower_id
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
  },
  getGaragesDwellerEdit (unit, tower) {
    if (typeof unit !== 'object') {
      const search = {
        unit_id: unit,
        tower_id: tower
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
  },
  getTowers () {
    this.$http.get('/v1/dweller/search/tower')
      .then((data) => {
        this.optionTowers = data.data
      })
  },
  tenantStatus (status) {
    if (status) {
      this.rental.status = false
    } else {
      this.rental.status = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/rental/form/resources/methods.js